import React from "react";

interface PanelResizeHandleProps {
  onPointerDown: (e: React.PointerEvent<HTMLDivElement>) => void;
  isDarkMode?: boolean;
}

/**
 * 右端固定パネルの左辺に置くドラッグハンドル。
 * 親要素に position（relative / fixed 等）が必要。
 */
export const PanelResizeHandle = ({
  onPointerDown,
  isDarkMode = false,
}: PanelResizeHandleProps) => (
  <div
    onPointerDown={onPointerDown}
    className={`absolute left-0 top-0 h-full w-1.5 -translate-x-1/2 cursor-col-resize z-10 transition-colors ${
      isDarkMode
        ? "hover:bg-gray-600/70 active:bg-gray-500/70"
        : "hover:bg-gray-300/70 active:bg-gray-400/70"
    }`}
    title="ドラッグで幅を変更"
    role="separator"
    aria-orientation="vertical"
    aria-label="詳細パネルの幅を変更"
  />
);
